import React from "react";
import { CtaButton } from "../CtaButton";
import { ContentIcon } from "../ContentIcon";
import { SectionHeading } from "../SectionHeading";
import { challenges } from "../../data/content";
export function Challenges() {
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-145" data-mp="2cy5y5ac2tyd3">
      <div className="mx-auto max-w-5xl" data-id="element-146" data-mp="2hx8so0ufkm6t">
        <SectionHeading eyebrow="Does any of this sound familiar?" title="If You Work With Autistic Children, You May Recognize These Challenges." data-id="element-147" data-mp="2hw7idyl8o3q5" />

        <ol className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-148" data-mp="280nlp9yup10c">
          {challenges.map((item, i) => <li key={item.title} className="flex gap-4 rounded-3xl bg-brand-soft p-5" data-id="element-149" data-mp="1u0uyvpqg34xn" data-mpi={i}>
              <div className="flex shrink-0 flex-col items-center gap-2" data-id="element-150" data-mp="1yy4n5223lajw">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-brand text-white" data-id="element-151" data-mp="3oe40ywgnvo5v">
                  <ContentIcon name={item.icon} className="h-6 w-6" data-id="element-152" data-mp="3tdgzwfkt4lot" />
                </span>
                <span className="text-sm font-black text-brand" data-id="element-153" data-mp="xc5ns9bdyh71">{i + 1}</span>
              </div>
              <div data-id="element-154" data-mp="tb257f1ye724">
                <h3 className="text-lg font-black leading-snug text-navy" data-id="element-155" data-mp="tblniwvimxgo">{item.title}</h3>
                {item.body.map(p => <p key={p} className="mt-2 text-[15px] font-semibold leading-relaxed text-ink/80" data-id="element-156" data-mp="171p1z1o5lmvk">
                    {p}
                  </p>)}
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl border-2 border-sun bg-sun-soft p-6 sm:p-8" data-id="element-157" data-mp="efcre46x908h">
          <p className="text-2xl font-black text-navy" data-id="element-158" data-mp="obpjwyqqd81n">Here’s What I Want You to Know.</p>
          <p className="mt-3 text-lg font-semibold leading-relaxed text-ink/85" data-id="element-159" data-mp="o9cu5zeqdte1">
            You don’t need to have every answer before you begin organizing your work.
          </p>
          <p className="mt-3 text-lg font-semibold leading-relaxed text-ink/85" data-id="element-160" data-mp="1zp1iov7mv0gy">
            You need a thoughtful process for gathering relevant information, identifying priorities, preparing
            resources, and documenting your next steps.
          </p>
          <p className="mt-3 text-lg font-black leading-relaxed text-navy" data-id="element-161" data-mp="26t19sqhbaga3">
            That’s the purpose of the Autism Communication Support Blueprint™.
          </p>
        </div>

        <div className="mt-10" data-id="element-162" data-mp="2gss3wr1ymt9n">
          <CtaButton label="Show me the complete system" sub="Secure Checkout · One-Time Payment of $27" data-id="element-163" data-mp="2gqxfv3ve6l1c" />
        </div>
      </div>
    </section>;
}